import { render, staticRenderFns } from "./device-tree.vue?vue&type=template&id=87d48246&scoped=true&"
import script from "./device-tree.vue?vue&type=script&setup=true&lang=ts&"
export * from "./device-tree.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./device-tree.vue?vue&type=style&index=0&id=87d48246&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d48246",
  null
  
)

/* custom blocks */
import block0 from "./device-tree.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports